import debounce from "lodash.debounce"
import fullscreenAPI from "../utils/fullscreen-api"
import { hideEndDisplay } from "./end-display"
import { isMobile, isTouchDevice } from "../utils/breakpoints"
import { isPlayerInCSSFullscreen, isPlayerInFullscreen } from "./player-fullscreen-util"
import { isPresentation } from "./presentation-types"
import { cssFullscreenOverlayBackdrop, fullscreenOverlay, player, slideContainer, toolbar } from "./selectors"
import logEvent from "../tracking/amplitude/log-event"

const enterAPIFullscreen = () => {
  hideEndDisplay()
  player.addClass("fullscreen")
  toolbar.hide()
  fullscreenAPI.requestNativeFullscreen(player[0])
}

const exitAPIFullscreen = () => {
  hideEndDisplay()
  player.removeClass("fullscreen")
  fullscreenOverlay.hide()
  toolbar.show()
  if (fullscreenAPI.isFullscreen) {
    fullscreenAPI.exitNativeFullscreen()
  }
}

const toggleFullscreenOverlay = () => {
  if (fullscreenOverlay.is(":visible")) {
    fullscreenOverlay.hide()
  } else {
    fullscreenOverlay.show()
  }
}

const handlePresentationsInLandscape = () => {
  if (isPresentation() && isMobile() && isPlayerInCSSFullscreen()) {
    slideContainer.css("max-height", "")
    slideContainer.css("min-height", "")
    slideContainer.css("max-height", window.innerHeight)
    slideContainer.css("min-height", window.innerHeight - 1)
  }
}

const enterCSSFullscreen = () => {
  $(
    "header#main-nav, .dwnld-btn-pos-right, .slideshow-info-container, .content-page-full-width, footer#modernize-footer"
  ).hide()
  $(".ad-container").addClass("hidden-for-fullscreen")
  toolbar.hide()
  player.addClass("fullscreen-css")
  cssFullscreenOverlayBackdrop.show()
  $("body").addClass("player-css-fullscreen")
  /**
   * Get the viewport height & multiply it by 1% to get a value for a vh unit
   * spec for viewport height is vague & accounted for differently on devices & browsers
   * More details about the issue - https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
   */
  //
  document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`)
  const mediaQueryList = window.matchMedia("(orientation: landscape)")
  if (mediaQueryList.matches) {
    // when used as landscape mode (default on mobile)
    debounce(() => {
      handlePresentationsInLandscape()
    }, 400)()
  }
}

const exitCSSFullscreen = () => {
  $(
    "header#main-nav, .dwnld-btn-pos-right, .slideshow-info-container, .content-page-full-width, footer#modernize-footer"
  ).show()
  $(".ad-container").removeClass("hidden-for-fullscreen")
  toolbar.show()
  player.removeClass("fullscreen-css")
  slideContainer.css("max-height", "")
  slideContainer.css("min-height", "")
  cssFullscreenOverlayBackdrop.hide()
  $("body").removeClass("player-css-fullscreen")
  fullscreenOverlay.hide()
}

export const enterFullscreen = () => {
  if (isMobile() && isTouchDevice()) {
    enterCSSFullscreen()
  } else if (fullscreenAPI.isFullscreenModeSupported && !fullscreenAPI.isFullscreen) {
    enterAPIFullscreen()
  }

  logEvent("slideshow_fullscreen_click", { click_type: "open" })
}

export const exitFullscreen = () => {
  if (isMobile() && isTouchDevice()) {
    exitCSSFullscreen()
  } else if (fullscreenAPI.isFullscreenModeSupported && fullscreenAPI.isFullscreen) {
    exitAPIFullscreen()
  }

  logEvent("slideshow_fullscreen_click", { click_type: "close" })
}

export const initializeFullscreen = () => {
  $("button#fullscreen").on("click", function (e) {
    e.preventDefault()
    e.stopPropagation()
    enterFullscreen()
  })

  $("#exit-fullscreen").on("click", function (e) {
    e.preventDefault()
    e.stopPropagation()
    exitFullscreen()
  })

  $("#new-player").on("click", function () {
    if (isPlayerInFullscreen()) {
      toggleFullscreenOverlay()
    }
  })

  /**
   * When player is in fullscreen & user clicks on download
   * exit fullscreen & then download, user should be able to
   * see the download progress.
   */
  $("button#player-fullscreen-overlay-download-cta").on("click", function () {
    if (isPlayerInFullscreen()) {
      exitFullscreen()
    }
  })

  /**
   * When player is in fullscreen & user clicks on clip slide
   * exit fullscreen, user is able to see the clipping dailog
   * and change the place clip is saved to.
   */
  $("button.player-fullscreen-overlay-clip-cta").on("click", function () {
    if (isPlayerInFullscreen()) {
      exitFullscreen()
    }
  })

  const portraitMode = window.matchMedia("(orientation: portrait)")

  portraitMode.addEventListener("change", function (e) {
    if (e.matches) {
      // In Portrait Mode
      debounce(() => {
        document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`)
        slideContainer.css("max-height", "")
        slideContainer.css("min-height", "")
      }, 400)()
    } else {
      // In Landscape Mode
      debounce(() => {
        document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`)
        handlePresentationsInLandscape()
      }, 400)()
    }
  })

  fullscreenAPI.addEventListener("fullscreenchange", () => {
    // After a keyboard-triggered exit event, isFullscreen will return false
    if (!fullscreenAPI.isFullscreen) {
      exitAPIFullscreen()
    }
  })
}
